import { animate, state, style, transition, trigger } from '@angular/animations';

export const RollWord = trigger('rollWord', [
  state('idle', style({ opacity: 0, transform: 'translateY(100%)' })),
  state('showing', style({ opacity: 1, transform: 'translateY(0)' })),
  state('hidden', style({ opacity: 0, transform: 'translateY(-100%)' })),
  transition('idle => showing', animate('250ms cubic-bezier(0, 0, 0.2, 1)')),
  transition('showing => hidden', animate('150ms cubic-bezier(0, 0, 0.2, 1)'))
]);
